"use strict";
// Funnels — multi-step sales flows: landing → opt-in → checkout → order bump →
// upsell / downsell → thank-you. Sells through Payments, like Shop.
//
// One-click upsells need a provider that can charge a saved method
// off-session (Stripe can; Razorpay can't for ad-hoc charges under RBI rules).
// That is an OPTIONAL feature requirement: without it the funnel still works
// and an upsell becomes a second, pre-filled checkout instead of one click.
//
// Step types are an extension point (`funnels.step@1`), so other plugins can
// add steps (a booking step from Bookings, a quiz step, a webinar step).
Object.defineProperty(exports, "__esModule", { value: true });
exports.FUNNELS_PLUGIN = exports.FUNNEL_STEP_TYPES = void 0;
exports.FUNNEL_STEP_TYPES = [
    'landing',
    'optin',
    'checkout',
    'order-bump',
    'upsell',
    'downsell',
    'thank-you',
];
exports.FUNNELS_PLUGIN = {
    id: 'funnels',
    version: '1.0.0',
    kind: 'capability',
    trust: 'first-party',
    title: 'Funnels',
    description: 'Sales funnels with opt-ins, checkout, order bumps, upsells and downsells, with conversion per step.',
    icon: 'i-ph:funnel',
    surfaces: ['web-app'],
    agentCard: 'Funnels: step-by-step sales flows with offers, order bumps and upsells (skills/funnels.md). Needs Payments.',
    requires: {
        'payments.checkout': { major: 1 },
        // One-click upsells. Optional: degrades to a second checkout.
        'payments.provider': { major: 1, optional: true, features: ['offSessionCharge'] },
    },
    provides: {
        'payments.purpose': {
            major: 1,
            features: { oneTime: true, subscriptions: true, upsell: true },
            meta: { purpose: 'funnel.offer' },
        },
        'funnels.step': [
            { major: 1, meta: { type: 'landing' } },
            { major: 1, meta: { type: 'optin' } },
            { major: 1, meta: { type: 'checkout' } },
            { major: 1, meta: { type: 'order-bump' } },
            { major: 1, meta: { type: 'upsell' } },
            { major: 1, meta: { type: 'downsell' } },
            { major: 1, meta: { type: 'thank-you' } },
        ],
    },
    declares: {
        'funnels.step': {
            major: 1,
            cardinality: 'many',
            description: 'A step type a funnel can contain.',
        },
    },
    emits: {
        'funnels.lead.captured': { major: 1, description: 'A visitor opted in at a funnel step.' },
        'funnels.offer.purchased': { major: 1, description: 'An offer (main, bump, upsell) was bought.' },
        'funnels.step.viewed': { major: 1, description: 'A visitor reached a step (for conversion per step).' },
    },
    subscribes: ['payments.payment.succeeded', 'payments.payment.refunded', 'forms.submitted'],
    permissions: ['db:own-tables', 'email:send'],
    targets: {
        'web-app': {
            skills: ['funnels'],
            lockedPaths: ['frontend/worker/dunea/funnels.ts', 'frontend/src/dunea/funnels.tsx'],
            detect: ['useFunnel'],
            tablePrefix: 'p_funnels_',
            budgetGzipKb: 25,
        },
    },
};
